import { State } from "xstate";

import { LeadFormStatus, SalesSegment } from "@brexhq/next/types/brex-api";

import { ErrorMessage } from "../FormSubmissionProvider";
import { LeadFormValues } from "../sharedTypes";

export enum LeadFormSteps {
  email = "email",
  monthlySales = "monthlySales",
  userInfo = "userInfo",
  ecommerce = "ecommerce",
  createLead = "createLead",
  createExistingLead = "createExistingLead",
  employeeCount = "employeeCount",
  updateLead = "updateLead",
  fundingSource = "fundingSource",
  error = "error",
  success = "success",
  waitlist = "waitlist",
  /**
   * Used to identify which "flow" to take the user to (sub state machines)
   */
  // 3P + PI MM, VB
  segVBOrPIMM = "segVBOrPIMM",
  // 3P + Enterprise, MM, Lower MM
  segLowerMMPlus = "segLowerMMPlus",
  // Non 3p
  segUnidentified = "segUnidentified",
  signup = "signup",
  website = "website",
  password = "password",
  industry = "industry",
  fundingSources = "fundingSources",
  /**
   * GTM Lead form
   */
  gtmEmail = "gtmEmail",
  gtmNon3PStepOne = "gtmNon3PStepOne",
  gtmNon3PStepTwo = "gtmNon3PStepTwo",
  gtmLowerMMPlus = "gtmLowerMMPlus",
  gtmVBPIMM = "gtmVBPIMM",
  gtmSuccess = "gtmSuccess",
  gtmExistingLead = "gtmExistingLead",
  gtmWebsite = "gtmWebsite",

  /**
   * GTM form email only
   */
  gtmInlineEmail = "gtmInlineEmail",

  /**
   * External event lead form
   */
  eventUserInfo = "eventUserInfo",
  eventSuccess = "eventSuccess",
  /**
   * OBS4 Steps
   */
  segSB = "segSB",
  segESTierTwo = "segESTierTwo",
  segGrowthTier1Plus = "segGrowthTier1Plus",
  segGrowthTier2 = "segGrowthTier2",
}

export enum leadFormEvents {
  submit = "submit",
  back = "back",
  updateField = "updateField",
  retry = "retry",
  invokeSegFlowVBEvent = "invokeSegFlowVBEvent",
  invokeSegFlowNonVB = "invokeSegFlowNonVB",
  existingLead = "existingLead",
  updateContext = "UPDATE_CONTEXT",
}

export type LeadFormStateMachineSend = (
  event: leadFormMachineEvent,
  payload?: object,
) => LeadFormStateMachineState;

export interface LeadFormStepSchema {
  states: {
    [key in LeadFormSteps]?: Record<string, any>;
  };
}

export type LeadFormStateMachineState = State<
  leadFormMachineContext,
  leadFormMachineEvent,
  LeadFormStepSchema,
  any,
  any
>;

/**
 * metadata only pertaining to the state machines and not used in any of our form
 * submissions
 */
export type LeadFormMachineMeta = {
  hasSeenMonthlySales?: boolean;
  hasSeenFundingSource?: boolean;
};

export type leadFormMachineContext = {
  salesSegment?: SalesSegment;
  leadToken: string;
  id: string;
  status: LeadFormStatus;
  errorMessage: ErrorMessage | null;
  existingLead: boolean;
  isGetDemo: boolean;
} & LeadFormValues &
  LeadFormMachineMeta;

export type leadFormMachineEvent =
  | { type: leadFormEvents.submit; value?: any }
  | { type: leadFormEvents.updateField; fields: LeadFormValues }
  | { type: leadFormEvents.back }
  | { type: leadFormEvents.retry }
  | { type: leadFormEvents.invokeSegFlowNonVB }
  | { type: leadFormEvents.invokeSegFlowVBEvent }
  | {
      type: leadFormEvents.existingLead;
    }
  | {
      type: leadFormEvents.updateContext;
      value: Partial<leadFormMachineContext>;
    };

export type leadFormMachineState = { value: any; context: any };

export type UpdateLeadResponse = {
  id: string;
  leadToken: string;
  salesSegment: SalesSegment;
};
